import { useEffect, useState } from "react";
import EditEmployeeModal from "views/app-views/employees/components/edit-employee";
import NewEmployeeModal from "views/app-views/employees/components/new-employee";
import EditPaiementModal from "views/app-views/employees/paiement/components/edit-paiement";
import NewSupplementModal from "views/app-views/creche/supplement/components/new-supplement";
import EditSupplementModal from "views/app-views/creche/supplement/components/edit-supplement";
import NewExpenseTypeModal from "views/app-views/creche/depensestypes/components/new-depensestype";
import EditExpenseTypeModal from "views/app-views/creche/depensestypes/components/edit-depensestypes";
import NewCategorieModal from "views/app-views/creche/SubscriptionCategories/components/new-categorie";
import EditCategorieModal from "views/app-views/creche/SubscriptionCategories/components/edit-categorie";
import NewDepense from "views/app-views/creche/ListeDipenses/components/new-dipense";
import EditExpense from "views/app-views/creche/ListeDipenses/components/edit-expense";
const ModalsProvider = () => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        if (!mounted) setMounted(true);
    }, [mounted]);

    if (!mounted) {
        return null;
    }

    return (
        <>
            <NewEmployeeModal />
            <EditEmployeeModal />
            <EditPaiementModal />
            <NewSupplementModal />
            <EditSupplementModal />
            <NewExpenseTypeModal />
            <EditExpenseTypeModal />
            <NewCategorieModal />
            <EditCategorieModal />
            <NewDepense />
            <EditExpense />
        </>
    );
};

export default ModalsProvider;
